export const getBarStatus = ({ barstatus }) => barstatus;
export const getMenus = ({ menus }) => menus;
export const getmodaldata = ({ modaldata }) => modaldata;
export const getToken = ({ token }) => token;
export const getLogUser = ({ logUser }) => logUser;
export const setUser = ({ user }) => user;
export const setRota = ({ rota }) => rota;
export const isLoggedIn = ({ state }) => state;
export const authStatus = ({ state }) => state;
export const getDatabase = ({ database }) => database;
export const getModalPagamento = ({ modalPagamento }) => modalPagamento;
export const getModalPessoa = ({ modalpessoa }) => modalpessoa;
export const getPedidoDataDetail = ({ pedidoDataDetail }) => pedidoDataDetail;
export const getEditModalPagamento = ({ pedidoEditModalPagamento }) => pedidoEditModalPagamento;
export const getModalCondPagamento = ({ modalCondPagamento }) => modalCondPagamento;
export const getAddModalTabVendas = ({ modalAddTabVendas }) => modalAddTabVendas;
export const getEditModalTabVendas = ({ modalEditTabVendas }) => modalEditTabVendas;
export const getGlobalRangeDate = ({ globalRange }) => globalRange;
export const getUpdateAdmUserTable = ({ updateAdmUserTable }) => updateAdmUserTable;
